<!-- #652: the card root is a positioning container, not the link itself. The body is one
     anchor to the detail page; the bookmark button is its SIBLING overlaid on the image,
     because an interactive control nested in an anchor is invalid and a `(click)` +
     stopPropagation() on a <div> would only look right while being unreachable by
     keyboard. -->
<article class="catalog-item-card" data-testid="catalog-item-card">
  <a class="card-link" [routerLink]="['/catalog-item', catalogSku().skuId]" data-testid="catalog-item-card-link">
    <div class="card-image">
      @if (imageUrl) {
        <img [src]="imageUrl" [alt]="catalogSku().skuName1" />
      }

      <!-- #509: the results read opts into `includeUnavailable`, so this grid is
           deliberately populated with listings nobody can order here. Without a state
           they look exactly like the orderable ones, which is the confusion #509 set out
           to prevent. Overlaid on the image rather than placed in the body, so the card's
           fixed text rhythm (clamped title, bottom-pinned price) keeps every tile in a
           row the same height.

           Only an explicitly known state badges here — app-catalog-item-detail also
           badges an absent or unrecognised one, because there the badge must not
           contradict the order action it suppresses. This card has no order action to
           contradict, and a pre-#509 backend sends no availability at all: matching the
           detail page's `!== 'available'` would then mislabel every result in the grid
           as unavailable. Staying silent degrades to today's behaviour instead. -->
      @if (isAvailableAtSource) {
        <span class="availability-badge badge text-bg-info" i18n="@@catalog.availability.atSource">
          Beim Anbieter erhältlich
        </span>
      } @else if (catalogSku().availability === 'unavailable') {
        <!-- #562 (decision 5): for an imported listing „Zurzeit nicht verfügbar" reads as if
             OUR stock had run out, when what we actually know is that the source shop reports
             none. Only the explicitly-unavailable state gets this wording — an unrecognised
             one says nothing about the seller and must not claim to. -->
        @if (catalogSku().isImported) {
          <span class="availability-badge badge text-bg-secondary" i18n="@@catalog.availability.unavailableAtSource">
            Beim Anbieter derzeit nicht verfügbar
          </span>
        } @else {
          <span class="availability-badge badge text-bg-secondary" i18n="@@catalog.availability.unavailable">
            Zurzeit nicht verfügbar
          </span>
        }
      }
    </div>

    <div class="card-body">
      <!-- backend #690: the listing's own language, so an English shop's product inside the
           German catalog is announced and hyphenated as English. Absent = undeclared, and then
           no attribute at all — the text inherits the page's language rather than being
           called German on a guess. -->
      <h3 class="card-title" [attr.lang]="contentLanguage">{{ catalogSku().skuName1 }}</h3>

      <div class="card-location">
        <fa-icon [icon]="faMapMarkerAlt" class="location-pin"></fa-icon>
        <div class="location-text">
          @if (distanceLabel()) {
            <span class="location-distance">{{ distanceLabel() }}</span>
          }
          <span class="location-seller">{{ catalogSku().sellerFullName }}</span>
        </div>
      </div>

      <div class="card-price">
        <span class="price-value">{{ catalogSku().catalogGrossPrice | currency: catalogSku().currency }}</span>
        <span class="price-note">{{ priceNote() || (catalogSku() | priceNote) }}</span>
      </div>
    </div>
  </a>

  @if (bookmarkAction()) {
    <button
      type="button"
      class="bookmark-toggle"
      data-testid="catalog-item-card-bookmark-button"
      [asyncClick]="bookmarkAction()"
      #bookmarkButton="asyncClick"
      [disabled]="bookmarkButton.disabled"
      [attr.aria-pressed]="isBookmarked()"
      [attr.aria-label]="bookmarkLabel"
      [attr.title]="bookmarkLabel"
      [attr.data-bookmarked]="isBookmarked()"
    >
      <fa-icon [icon]="bookmarkIcon"></fa-icon>
    </button>
  }
</article>
